import {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {createNewPayment} from '~/api/finance/newPayments';
import {ToastType} from '~/components/Toast/constant';
import toast from '~/utils/toast';
import {RouteSection, getRoute} from '$utils/route';
import {RoutePath} from '$constants/routes';

interface UseNewPaymentReturn {
  isLoading: boolean;
  createPayment: (patientId: number) => Promise<void>;
}

export const useNewPayment = (): UseNewPaymentReturn => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const createPayment = async (patientId: number) => {
    try {
      setIsLoading(true);
      const response = await createNewPayment({
        payment: {
          patient_id: patientId,
        },
      });

      if (response.success) {
        navigate(
          getRoute(
            RouteSection.Finance,
            `${RoutePath.staff.finance.payments}/${response.data.id}`
          ),
          {
            state: {
              billingDate: response.data.billing_date,
              billingTime: new Date().toLocaleTimeString(),
            },
          }
        );
      }
    } catch (error) {
      console.error('Error creating new payment:', error);
      toast(
        ToastType.Error,
        'Payment Creation Failed',
        'Failed to create payment. Please try again.'
      );
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    createPayment,
  };
};
